import React, {Fragment} from "react";

const TicketsSideBar = ({ toggleTicketModal, updateFilters }) => {

    return (
        <Fragment>


            <div
                className={`bg-white tickets-sidebar-collapsed tickets-table-container display-flex flex-direction-column overflow-auto p-20 border-radius-10`}>

                <div className="sidebar-tickets">

                    {/* Button to open the ticket modal */}
                    <div className={"flex "}>

                <span className="btn-submit-account ml-0 p-10 gap-20" onClick={toggleTicketModal}>
          <i className="fas fa-solid fa-plus mr-10"/>Créer un ticket
        </span>
                    </div>


                    {/* Button to clear filters */}
                    <div className={"flex"} onClick={() => updateFilters({status: 'all', assigned: false})}>
  <span className="btn-submit-account ml-0 p-10 gap-20">
            <i className="fas fa-solid fa-list mr-10"/>Tous les tickets en cours
          </span>
                    </div>


                    <div className={"flex active"}
                         onClick={() => updateFilters({status: "MesAssignés", assigned: false})}>
  <span className="btn-submit-account ml-0 p-10 gap-20">
    <i className="fas fa-user-tag mr-10"/> Mes tickets en cours
  </span>
                    </div>

                    {/* Clôturé button */}
                    <div className={"flex"} onClick={() => updateFilters({status: "Clôturé", assigned: false})}>
  <span className="btn-submit-account ml-0 p-10 gap-20">
    <i className="fas fa-check mr-10"/> Tickets clôturés
  </span>
                    </div>

                    {/* Button to clear filters */}
                    <div className={"flex"} onClick={() => updateFilters({status: null, assigned: false})}>
  <span className="btn-submit-account ml-0 p-10 reinit-filters gap-20">
            <i className="fas fa-solid fa-times mr-10"/> Réinitialiser les filtres
          </span>
                    </div>

                </div>
            </div>
        </Fragment>
    );
};

export default TicketsSideBar;
